// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum MediaRequestStatuses {
	Complete = 0,
	Expired = 1,
	Recording = 2,
	Merging = 3,
	Uploading = 4,
	Scheduled = 5,
	Cancelled = 6,
	Error = 7,
	MergingVideo = 10,
	MergingRadar = 11,
	PartiallyComplete = 100,
}

export const MediaRequestStatusesDisplayNames: { [key in keyof typeof MediaRequestStatuses]?: string} = {
	"Complete": "Complete",
	0 : "Complete",
	"Expired": "Expired",
	1 : "Expired",
	"Recording": "Recording",
	2 : "Recording",
	"Merging": "Merging",
	3 : "Merging",
	"Uploading": "Uploading",
	4 : "Uploading",
	"Scheduled": "Scheduled",
	5 : "Scheduled",
	"Cancelled": "Cancelled",
	6 : "Cancelled",
	"Error": "Error",
	7 : "Error",
	"MergingVideo": "MergingVideo",
	10 : "MergingVideo",
	"MergingRadar": "MergingRadar",
	11 : "MergingRadar",
	"PartiallyComplete": "PartiallyComplete",
	100 : "PartiallyComplete",
}

export const getMediaRequestStatusesDisplayName = (key: MediaRequestStatuses | (keyof typeof MediaRequestStatuses & string)) => {
	return MediaRequestStatusesDisplayNames[key];
}

